var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarnedIncome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 15.4141,
    width: 37,
    height: 30,
    rx: 8,
    fill: "#12B1B4",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5 16.3359H36.25C39.1495 16.3359 41.5 18.6864 41.5 21.5859V28.5859C41.5 31.4854 39.1495 33.8359 36.25 33.8359H18.75C15.8505 33.8359 13.5 31.4854 13.5 28.5859V26.8359H11.75C8.85051 26.8359 6.5 24.4854 6.5 21.5859V14.5859C6.5 11.6864 8.85051 9.33594 11.75 9.33594H29.25C32.1495 9.33594 34.5 11.6864 34.5 14.5859V16.3359ZM29.25 11.0859H11.75C9.817 11.0859 8.25 12.6529 8.25 14.5859V21.5859C8.25 23.5189 9.817 25.0859 11.75 25.0859H13.5V21.5859C13.5 18.6864 15.8505 16.3359 18.75 16.3359H32.75V14.5859C32.75 12.6529 31.183 11.0859 29.25 11.0859ZM18.75 18.0859H36.25C38.183 18.0859 39.75 19.6529 39.75 21.5859V28.5859C39.75 30.5189 38.183 32.0859 36.25 32.0859H18.75C16.817 32.0859 15.25 30.5189 15.25 28.5859V21.5859C15.25 19.6529 16.817 18.0859 18.75 18.0859Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5 26.8359C28.4665 26.8359 29.25 26.0524 29.25 25.0859C29.25 24.1194 28.4665 23.3359 27.5 23.3359C26.5335 23.3359 25.75 24.1194 25.75 25.0859C25.75 26.0524 26.5335 26.8359 27.5 26.8359ZM27.5 28.5859C29.433 28.5859 31 27.0189 31 25.0859C31 23.1529 29.433 21.5859 27.5 21.5859C25.567 21.5859 24 23.1529 24 25.0859C24 27.0189 25.567 28.5859 27.5 28.5859Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 26.8359C21.4665 26.8359 22.25 26.0524 22.25 25.0859C22.25 24.1194 21.4665 23.3359 20.5 23.3359C19.5335 23.3359 18.75 24.1194 18.75 25.0859C18.75 26.0524 19.5335 26.8359 20.5 26.8359Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5 26.8359C35.4665 26.8359 36.25 26.0524 36.25 25.0859C36.25 24.1194 35.4665 23.3359 34.5 23.3359C33.5335 23.3359 32.75 24.1194 32.75 25.0859C32.75 26.0524 33.5335 26.8359 34.5 26.8359Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnedIncome);
export default __webpack_public_path__ + "static/media/earned-income.a18999b610144cc4355b5e0d2a32fe15.svg";
export { ForwardRef as ReactComponent };